import { z } from "zod";

export const patchIncomingInvoiceApprovalParamsSchema = z.object({
	incomingInvoiceId: z.uuid(),
	approvalId: z.uuid(),
});

export type PatchIncomingInvoiceApprovalParamsSchema = z.infer<
	typeof patchIncomingInvoiceApprovalParamsSchema
>;
